import type { NextRouter } from 'next/router';
import type { TypedAction } from '@peloton/redux/TypedAction';

export enum WorkoutHistoryPageActionTypes {
  RequestMoreWorkouts = 'members/workoutHistory/workouts/REQUEST_NEXT_PAGE',
  RequestNewWorkouts = 'members/workoutHistory/INITIALIZE',
}

type Dates = {
  fromDate: string;
  toDate: string;
};

export const requestNewWorkouts = (
  { fromDate, toDate }: Dates,
  router: NextRouter,
  sharedLeaderboardTag: string | null,
) => ({
  type: WorkoutHistoryPageActionTypes.RequestNewWorkouts,
  payload: { sharedLeaderboardTag, fromDate, toDate, router },
});

export const requestMoreWorkouts = ({ fromDate, toDate }: Dates, router: NextRouter) => ({
  type: WorkoutHistoryPageActionTypes.RequestMoreWorkouts,
  payload: { fromDate, toDate, router },
});

export type WorkoutHistoryAction =
  | TypedAction<
      ReturnType<typeof requestNewWorkouts>,
      WorkoutHistoryPageActionTypes.RequestNewWorkouts
    >
  | TypedAction<
      ReturnType<typeof requestMoreWorkouts>,
      WorkoutHistoryPageActionTypes.RequestMoreWorkouts
    >;
